<template>
  <b-card-body>
    <b-tabs 
      v-if="relatie"
      v-model="activeTab"
      content-class="mt-3"
    >
      <!-- ============================================================ -->
      <!-- TAB 1 : Basisgegevens                                         -->
      <!-- ============================================================ -->
      <b-tab title="Basisgegevens" active>
        <template #title>
          <i class="cui-info" /> Basisgegevens
        </template>
        <b-row>
          <b-col cols="2">
            <cloud-foto
              :url="'/relaties/' + relatie.Id + '/logo'"
              title="Klantlogo"
              preset="logo_upload"
              uploadfolder="/logos/"
            />
          </b-col>
          <b-col cols="10">
            <b-form-row>
              <b-col cols="6">
                <b-form-group label="Bedrijfsnaam">
                  <b-form-input 
                    v-model="relatie.Naam" 
                    :disabled="!relatie.NaamTeWijzigen"
                    type="text" 
                    placeholder="..."
                  />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Onderhoudsfirma">
                  <b-checkbox v-model="relatie.IsOnderhoudsfirma" />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Adviesnummer">
                  <b-form-input 
                    v-model="relatie.Adviesnummer" 
                    type="text" 
                    placeholder="..."
                  />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group 
                  v-if="relatie.Groep" 
                  label="Groep"
                >
                  <b-form-input 
                    v-model="relatie.Groep.Id" 
                    type="text" 
                    placeholder="..." 
                    disabled
                  />
                </b-form-group>
                <span v-else>Relatie is groep</span>
              </b-col>
            </b-form-row>
          </b-col>
        </b-row>
      </b-tab>

      <!-- ============================================================ -->
      <!-- TAB 2 : Contact & Adres                                       -->
      <!-- ============================================================ -->
      <b-tab>
        <template #title>
          <i class="cui-envelope-letter" /> Contact & Adres
        </template>

        <h5 class="mb-3">Adres en correspondentie</h5>
        <b-form-row>
          <b-col cols="8">
            <b-form-row>
              <b-col>
                <b-form-group label="Adres">
                  <b-form-input 
                    v-model="relatie.Adres" 
                    type="text" 
                    placeholder="Straatnaam + nummer"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group label="Postcode">
                  <b-form-input 
                    v-model="relatie.Postcode" 
                    type="text" 
                    placeholder="1000 AA"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Plaats">
                  <b-form-input 
                    v-model="relatie.Plaats" 
                    type="text" 
                    placeholder="...."
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-col>
          <b-col>
            <b-form-group 
              label="Aangepast factuuradres" 
              description="Dit veld wordt het standaard adres voor facturen"
            >
              <b-textarea 
                v-model="relatie.Config.facturatieadres"
                rows="5"   
              />
            </b-form-group>
          </b-col>
        </b-form-row>

        <h5 class="mt-4 mb-3">Postbus</h5>
        <b-form-row>
          <b-col cols="4">
            <b-form-group label="Postbus">
              <b-form-input 
                v-model="relatie.Postbus" 
                type="text" 
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group 
              label="Postcode" 
              description="postcode van postbus"
            >
              <b-form-input 
                v-model="relatie.PostbusCode" 
                type="text" 
                placeholder="...."
              />
            </b-form-group>
          </b-col>
        </b-form-row>

        <h5 class="mt-4 mb-3">Direct contact</h5>
        <b-form-row>
          <b-col cols="3">
            <b-form-group label="Telefoon">
              <b-form-input 
                v-model="relatie.Telefoon" 
                type="text" 
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Fax">
              <b-form-input 
                v-model="relatie.Fax" 
                type="text" 
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="E-mail">
              <b-form-input 
                v-model="relatie.Email" 
                type="email" 
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Financiële administratie">
              <b-form-input 
                v-model="relatie.FinEmail" 
                type="email" 
                placeholder="E-mailadres"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="3">
            <b-form-group label="Storingnummer">
              <b-form-input 
                v-model="relatie.Storingnummer" 
                type="text" 
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group 
              label="Storingsemail" 
              description="Voor het (door)melden van storingen"
            >
              <b-form-input 
                v-model="relatie.StoringEmail" 
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-tab>

      <!-- ============================================================ -->
      <!-- TAB 3 : Instellingen & Configuratie                           -->
      <!-- ============================================================ -->
      <b-tab>
        <template #title>
          <i class="cui-settings" /> Instellingen
        </template>

        <h5 class="mb-3">Rapportage & weergave</h5>
        <b-form-row>
          <b-col cols="3">
            <b-form-group
              label="Stuur door API melding"
              description="Bij het doen van een eigen melding"
            >
              <b-form-checkbox v-model="relatie.Config.stuurEigenAPIMelding" />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group 
              label="Toon NEN opmerking" 
              description="Bij het rapport"
            >
              <b-form-checkbox v-model="relatie.Config.toonNENOpmerking" />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Toon IO score"
              description="Vermelding belang, intensiteit, omvang"
            >
              <b-form-checkbox v-model="relatie.Config.toonIOScore" />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Omdraaien unit en complex foto"
              description="Draai de unit foto en complex foto om"
            >
              <b-form-checkbox v-model="relatie.Config.flipFotosComplexUnit" />
            </b-form-group>
          </b-col>
        </b-form-row>

        <h5 class="mt-4 mb-3">Standaard condities</h5>
        <b-form-row>
          <b-col cols="6">
            <b-form-group 
              label="Conditie bij vervanging" 
              description="Conditie na vervanging"
            >
              <b-form-radio-group
                v-model.number="relatie.Config.standaardConditieVervanging"
                :options="[1,2,3,4,5,6]"
                size="sm"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group 
              label="Conditie bij revisie" 
              description="Conditie na revisie"
            >
              <b-form-radio-group
                v-model.number="relatie.Config.standaardConditieRevisie"
                :options="[1,2,3,4,5,6]"
                size="sm"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
          </b-col>
        </b-form-row>

        <h5 class="mt-4 mb-3">Contract</h5>
        <b-form-row>
          <b-col cols="4">
            <b-form-group 
              label="Contract index" 
              description="De afgesproken index voor deze relatie"
            >
              <b-form-input
                v-model.number="relatie.Config.indexContract"
                type="number"
                placeholder="Geen contract index"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group 
              label="Geldig tot" 
              description="Tot wanneer deze index geldig is"
            >
              <date-input
                :date="relatie.Config.indexEinddatum || null"
                @date-changed="relatie.Config.indexEinddatum = $event != null ? $event.toISOString() : null"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Wat is opdracht">
              <b-check-group 
                v-model="relatie.Config.afspraken"
                :options="services"
                stacked
              />
            </b-form-group>
          </b-col>
        </b-form-row>

        <h5 class="mt-4 mb-3">Kaart & prioriteiten</h5>
        <b-form-row>
          <b-col cols="6">
            <b-form-group 
              label="Kaart midden" 
              description="Centraal punt voor de kaart"
            >
              <b-input-group prepend="lat">
                <b-input v-model.number="relatie.Config.googleMap.lat" />
                <b-input-group-text is-text>
                  lng
                </b-input-group-text>
                <b-input v-model.number="relatie.Config.googleMap.lng" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <aspect-prioriteit-matrix 
              :aspecten="relatie.Config.prioriteiten || undefined" 
              @on-update="relatie.Config.prioriteiten = $event"
            />
            <b-button 
              size="sm"
              class="mb-4" 
              @click="$set(relatie.Config,'prioriteiten',null)"
            >
              <font-awesome-icon 
                icon="refresh" 
                class="mx-3"
              /> Reset aspect prioriteiten
            </b-button>
          </b-col>
        </b-form-row>
      </b-tab>

      <!-- ============================================================ -->
      <!-- TAB 4 : E-mail routering                                      -->
      <!-- ============================================================ -->
      <b-tab>
        <template #title>
          <i class="cui-envelope-open" /> E-mail routering
        </template>

        <h5 class="mb-3">Standaard e-mailadressen</h5>
        <p class="text-muted small">
          Deze e-mailadressen worden gebruikt voor de standaard correspondentie (per categorie).
        </p>
        <b-form-row>
          <b-col cols="8">
            <div 
              v-for="(email,key) in relatie.Config.emailadressen" 
              :key="key"
            >
              <b-input-group class="m-1">
                <b-input-group-prepend>
                  <b-input-group-text style="min-width:140px;">
                    {{ email.type.omschrijving }}
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-input 
                  v-model="email.adres" 
                  type="email"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-danger"
                    @click="$delete(relatie.Config.emailadressen, key);"
                  >
                    verwijderen
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <b-form-group label="E-mailadres toevoegen" class="mt-3">
              <b-input-group>
                <b-input-group-prepend>
                  <b-select v-model="email.type">
                    <option
                      v-for="(option,i) in opties"
                      :key="i"
                      :value="option"
                    >
                      voor {{ option.omschrijving }}
                    </option>
                  </b-select>
                </b-input-group-prepend>
                <b-input 
                  v-model="email.adres" 
                  type="email" 
                  placeholder="Emailadres..."
                />
                <b-input-group-append is-text>
                  <font-awesome-icon :icon="validEmail(email.adres) ? 'user' : 'times'" />
                </b-input-group-append>
                <b-input-group-append>
                  <b-button
                    :disabled="email.type == null || !validEmail(email.adres)"
                    variant="outline-success"
                    @click="AddEmail"
                  >
                    toevoegen
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-form-row>

        <hr class="my-4">

        <h5 class="mb-3">E-mail routering voor Documenten</h5>
        <p class="text-muted small">
          Deze e-mailadressen worden gebruikt als suggestie (autofill) bij het versturen van documenten (PDF) vanuit Documenten. 
          Selecteer één of meerdere complexen waarvoor dit e-mailadres geldt. 
          De naam wordt automatisch voorgesteld op basis van de Unit-titel maar kan worden aangepast.
        </p>

        <div 
          v-for="(route, idx) in (relatie.Config.documentRoutering || [])" 
          :key="idx"
          class="border rounded p-2 mb-2"
        >
          <b-form-row>
            <b-col cols="3">
              <b-form-group label="Naam" label-size="sm">
                <b-input 
                  v-model="route.naam" 
                  size="sm" 
                  placeholder="bv. VVE De Roos"
                />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="E-mailadres" label-size="sm">
                <b-input 
                  v-model="route.email" 
                  type="email"
                  size="sm" 
                  placeholder="naam@voorbeeld.nl"
                  :state="route.email ? (validEmail(route.email) && !isDuplicateEmail(idx)) : null"
                />
                <b-form-invalid-feedback 
                  v-if="route.email && !validEmail(route.email)" 
                  force-show
                >
                  Dit is geen geldig e-mailadres.
                </b-form-invalid-feedback>
                <b-form-invalid-feedback 
                  v-else-if="route.email && isDuplicateEmail(idx)" 
                  force-show
                >
                  Dit e-mailadres is al gebruikt in een andere regel.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Complex(en)" label-size="sm">
                <multiselect
                  v-if="complexenOpties.length > 0"
                  :value="getRouteComplexen(route)"
                  :options="complexenOpties"
                  :multiple="true"
                  :close-on-select="false"
                  track-by="Id"
                  label="Label"
                  placeholder="Kies complex(en)..."
                  @input="setRouteComplexen(route, $event)"
                />
                <small v-else class="text-muted">Complexen laden...</small>
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group label-size="sm">
                <template #label>
                  Autofill
                  <span
                    v-b-tooltip.hover
                    title="Indien aangevinkt wordt dit e-mailadres automatisch vooringevuld bij het versturen van documenten voor de gekozen complexen. Uitgevinkt: het adres is alleen beschikbaar als suggestie."
                  >
                    <font-awesome-icon 
                      icon="info-circle"
                      class="ml-1 text-muted"
                    />
                  </span>
                </template>
                <b-form-checkbox v-model="route.autofill" />
              </b-form-group>
            </b-col>
            <b-col cols="1" class="text-right">
              <b-form-group label=" " label-size="sm">
                <b-button 
                  size="sm" 
                  variant="outline-danger"
                  @click="removeDocumentRoute(idx)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>

        <b-alert 
          v-if="(relatie.Config.documentRoutering || []).length === 0"
          show 
          variant="light"
          class="small"
        >
          Nog geen extra e-mailadressen geconfigureerd voor document-routering.
        </b-alert>

        <b-button 
          size="sm" 
          variant="outline-primary" 
          @click="addDocumentRoute"
        >
          <font-awesome-icon icon="plus" /> Regel toevoegen
        </b-button>
      </b-tab>
    </b-tabs>

    <!-- ============================================================ -->
    <!-- Bottom action bar — Opslaan                                   -->
    <!-- ============================================================ -->
    <div class="d-flex justify-content-end mt-4 pt-3 border-top">
      <b-button 
        variant="success" 
        size="lg"
        @click="onSave"
      >
        <font-awesome-icon icon="save" class="mr-2" /> Opslaan
      </b-button>
    </div>
  </b-card-body>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import CloudFoto from "@/components/CloudFoto";
import AspectPrioriteitMatrix from '@/components/AspectPrioriteitMatrix.vue';
import DateInput from '../../components/DateInput.vue';
import Multiselect from 'vue-multiselect';


export default {
  name: "RelatieEdit",
  components: {
    CloudFoto,
    AspectPrioriteitMatrix,
    DateInput,
    Multiselect
  },
  mixins: [serviceMixin],
   props: {
    relatie: {
      type: Object,
      default: () => {}
    },
    opties: {
      type:Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: 0,
      email: {
        type: null,
        adres: null
      },
      complexen: [],
      services: [
        {value:'NINSP',text:'0-inspectie'},
        {value:'HERINSP',text:'Her-inspecties'},
        {value:'POH',text:'Planmatig onderhoud'},
        {value:'POHK',text:'Planmatig onderhoud begeleiding klein'},
        {value:'POHG',text:'Planmatig onderhoud begeleiding groot'},
        {value:'FB',text:'Facturen beoordelen'},
        {value:'OB',text:'Offerte beoordeling'},
        {value:'KE',text:'Keuringen'}
      ]
    };
  },
  computed: {
    complexenOpties() {
      return (this.complexen || []).map((c) => ({
        Id: c.Id,
        Label: `${c.Complexnummer} — ${c.TitelSuggestie}`,
        TitelSuggestie: c.TitelSuggestie,
        AantalUnits: c.AantalUnits
      }));
    }
  },
  watch: {
    relatie: {
      immediate: true,
      handler(val) {
        if (val && val.Id && this.complexen.length === 0) {
          this.fetchComplexen(val.Id);
        }
        // Zorg dat de property bestaat zodat Vue reactiviteit werkt
        if (val && val.Config && !Array.isArray(val.Config.documentRoutering)) {
          this.$set(val.Config, 'documentRoutering', []);
        }
      }
    }
  },
  methods: {
    fetchComplexen(relatieId) {
      var vm = this;
      this.get(`/relaties/${relatieId}/complexen`)
        .then((response) => {
          vm.complexen = response.data.complexen || [];
        })
        .catch((error) => {
          console.log('Fout bij laden complexen voor routering:', error);
        });
    },
    getRouteComplexen(route) {
      var ids = route.complexIds || [];
      return this.complexenOpties.filter((o) => ids.indexOf(o.Id) > -1);
    },
    setRouteComplexen(route, selected) {
      this.$set(route, 'complexIds', (selected || []).map((o) => o.Id));
      // Als er nog geen naam is, vul de Titel-suggestie van het eerste complex
      if ((!route.naam || route.naam === '') && selected && selected.length > 0) {
        this.$set(route, 'naam', selected[0].TitelSuggestie);
      }
    },
    addDocumentRoute() {
      if (!Array.isArray(this.relatie.Config.documentRoutering)) {
        this.$set(this.relatie.Config, 'documentRoutering', []);
      }
      this.relatie.Config.documentRoutering.push({
        naam: '',
        email: '',
        complexIds: [],
        autofill: true
      });
    },
    removeDocumentRoute(idx) {
      this.relatie.Config.documentRoutering.splice(idx, 1);
    },
    onSave() {
      var routes = this.relatie.Config.documentRoutering || [];
      var hasDuplicates = routes.some((r, i) => this.isDuplicateEmail(i));
      if (hasDuplicates) {
        this.activeTab = 3;
        this.$bvToast.toast(
          'Er zijn dubbele e-mailadressen in de document-routering. Verwijder de dubbele adressen voordat je opslaat.',
          {
            title: 'Dubbel e-mailadres',
            variant: 'danger',
            solid: true
          }
        );
        return;
      }
      this.$emit('save');
    },
    isDuplicateEmail(idx) {
      var routes = this.relatie.Config.documentRoutering || [];
      var email = (routes[idx] && routes[idx].email || '').trim().toLowerCase();
      // Eerst controleren of het een geldig e-mailadres is, daarna pas op duplicaten checken
      if (email === '' || !this.validEmail(email)) return false;
      return routes.some((r, i) => 
        i !== idx && (r.email || '').trim().toLowerCase() === email
      );
    },
    AddEmail: function() {
      this.$set(this.relatie.Config.emailadressen, this.email.type.code, {
        adres: this.email.adres,
        type: this.email.type
      });
      this.isDirty = true;
    },
    parseValue(val) {
      if (val === null || val === undefined || val === '') return false
      if (val === '0' || val === false || val === 0) return false
      if (val === '1' || val === true || val === 1) return true
      return Boolean(val)
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* Dark mode overrides voor vue-multiselect */
.multiselect__tags,
.multiselect__input,
.multiselect__single {
  background: #2f353a;
  color: #e4e7ea;
  border-color: #23282c;
}

.multiselect__input::placeholder,
.multiselect__placeholder {
  color: #73818f;
}

.multiselect__content-wrapper {
  background: #2f353a;
  color: #e4e7ea;
  border-color: #23282c;
}

.multiselect__option {
  color: #e4e7ea;
}

.multiselect__option--highlight {
  background: #20a8d8; /* CoreUI primary */
  color: #fff;
}

.multiselect__option--highlight::after {
  background: #20a8d8;
  color: #fff;
}

.multiselect__option--selected {
  background: #23282c;
  color: #e4e7ea;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: #f86c6b; /* CoreUI danger, voor deselect hover */
  color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight::after {
  background: #f86c6b;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8;
  color: #fff;
}

.multiselect__tag-icon:hover {
  background: #1985ac;
}

.multiselect__tag-icon::after {
  color: #fff;
}

.multiselect__select::before {
  border-color: #e4e7ea transparent transparent;
}

.multiselect--active .multiselect__tags {
  border-color: #20a8d8;
}
</style>
